var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-col",
            { style: { paddingLeft: "0" }, attrs: { xs: "6" } },
            [
              _c("w-date-picker", {
                ref: "datePicker",
                attrs: {
                  label: _vm.$ct("labels.date"),
                  locale: _vm.locale,
                  fancy: "",
                  "popover-visibility": "focus",
                },
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { style: { paddingLeft: "0" }, attrs: { xs: "6" } },
            [
              _c("w-input-time", {
                attrs: { label: _vm.$ct("labels.time"), fancy: "" },
                model: {
                  value: _vm.time,
                  callback: function ($$v) {
                    _vm.time = $$v
                  },
                  expression: "time",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            {
              staticClass: "mts",
              style: { paddingLeft: "0" },
              attrs: { xs: "6" },
            },
            [
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("labels.calendar") },
                model: {
                  value: _vm.addOnCalendar,
                  callback: function ($$v) {
                    _vm.addOnCalendar = $$v
                  },
                  expression: "addOnCalendar",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-textarea", {
        staticClass: "mt",
        attrs: { label: _vm.$ct("labels.description"), fancy: "" },
        model: {
          value: _vm.appointment.Message,
          callback: function ($$v) {
            _vm.$set(_vm.appointment, "Message", $$v)
          },
          expression: "appointment.Message",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }